import React, {useState} from "react";

import {
  Alert,
  AlertIcon,
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Heading,
  Input,
  Text,
  UnorderedList,
  ListItem,
} from "@chakra-ui/react";

import DefaultAuth from "../../../components/auth/Default";

function SignIn() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [succes, setSucces] = useState("");
  const textColor = "navy.700";
  const textColorSecondary = "gray.400";
  const brandStars = "brand.500";
  const cardColor = 'gray.50';
  const boxStyle = {
    boxShadow: '-1px 3px 400px 80px rgba(135, 135, 135, 0.25)',
    WebkitBoxShadow: '-1px 3px 400px 80px rgba(135, 135, 135, 0.25)',
    MozBoxShadow: '-1px 3px 400px 80px rgba(135, 135, 135, 0.25)'
  };
  const HandleReset = async (event) => {
    event.preventDefault();
    

    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    
    if (!token) {
      setError("Geçersiz şifre sıfırlama bağlantısı");
      return;
    }
    
    const requestBody = {
      password: password,
      token: token
    };

    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      };

       const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}auth/reset/confirm/`,
        requestOptions
      );
      const data = await response.json();
      if(response.ok) {
        setSucces(true);
        setError("");
        setTimeout(() => {
          window.location.href = "/giris";
        }, 3000);
      } else {
        setError(
          data.message || "Şifre güncellenirken bir hata oluştu. Lütfen tekrar deneyin."
        );
      }
    } catch (error) {
      setError("Bir hata ile karşılaşıldı, Lütfen tekrar deneyiniz.");
    }
  };

 return (
    <form onSubmit={HandleReset}>
    <DefaultAuth
      illustrationBackground={"https://inohom.b-cdn.net/newImages/inohomtrlogo.png"}
    >
      <Flex
        style={boxStyle}
        bg={cardColor}
        maxW={{base: "max-content", md: "max-content"}}
        boxShadow='xl' p='6' rounded='md'
        borderRadius="10px"
        alignItems="start"
        justifyContent="center"
        flexDirection="column"
      >
        <Box me="auto">
          <Heading color={textColor} fontSize="32px" mb="10px">
            Yeni Şifre Belirleme
          </Heading>
          <Text
            maxW={"420px"}
            mb="36px"
            ms="4px"
            color={textColorSecondary}
            fontWeight="400"
            fontSize="md"
          >
            Lütfen hesabınız için yeni bir şifre belirleyin. Güvenliğiniz için güçlü bir şifre seçmeyi unutmayın.
          </Text>
        </Box>
        <Flex
          direction="column"
          w={{base: "100%", md: "420px"}}
          maxW="100%"
          background="transparent"
          borderRadius="15px"
          mx={{base: "auto", lg: "unset"}}
          me="auto"
          mb={{base: "10px", md: "auto"}}
        >
          <FormControl isInvalid={error !== ""}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Yeni Şifreniz<Text color={brandStars}>*</Text>
            </FormLabel>
            <Input
              isRequired={true}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="password"
              placeholder="••••••••"
              fontWeight="500"
              size="lg"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              mb="15px"
            />
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Şifrenizi Doğrulayın<Text color={brandStars}>*</Text>
            </FormLabel>
            <Input
              isRequired={true}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="password"
              placeholder="••••••••"
              fontWeight="500"
              size="lg"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <FormErrorMessage>{error}</FormErrorMessage>
          </FormControl>
          <Alert status='info' variant='left-accent' mt="4" mb="4">
            <AlertIcon />
            <Box>
              Şifreniz:
              <UnorderedList>
                <ListItem>En az 8 karakter uzunluğunda olmalı</ListItem>
                <ListItem>En az 1 büyük harf içermeli</ListItem>
                <ListItem>En az 1 küçük harf içermeli</ListItem>
                <ListItem>En az 1 rakam içermeli</ListItem>
              </UnorderedList>
            </Box>
          </Alert>
            <Button
              mt="24px"
              backgroundColor={"#660000"}
              color={"#fff"}
              fontSize="sm"
              variant="brand"
              borderRadius={9}
              onClick={HandleReset}
              fontWeight="500"
              w="100%"
              h="50"
              isLoading={loading}
              mb="24px"
              type="submit"
              isDisabled={succes}
            >
              Şifreyi Güncelle
            </Button>
          {succes && (
            <Alert status='success' variant='left-accent'>
              <AlertIcon />
              Şifreniz başarıyla güncellendi! Yeni şifrenizle giriş yapabilirsiniz.
            </Alert>
          )}
          <Flex
            flexDirection="column"
            justifyContent="center"
            alignItems="start"
            maxW="100%"
            mt="0px">
          </Flex>
        </Flex>
      </Flex>
    </DefaultAuth>
    </form>
  );
}

export default SignIn;
